import React from 'react';
import { useEffect } from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useForm } from 'antd/lib/form/Form';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

import { DIRECTION } from '@/components/ui/StepsNavigation/types';
import { StepsNavigation } from '@/components/ui/StepsNavigation';
import type { Step } from '@/hooks/useGetCustomReport';
import { useGetOWASReport } from './hooks/useGetOwasReport';
import { Informations, Evaluation, Result } from './Steps';
import { useOWASContext } from './context';
import { StepsContainer } from './styles';

const steps: Step[] = [
	{
		id: 'information',
		name: I18n.get('Information'),
		sequence: 0,
		description: I18n.get('General informations'),
		component: <Informations />
	},
	{
		id: 'evaluation',
		name: I18n.get('Evaluation'),
		sequence: 1,
		description: I18n.get('Evaluation'),
		component: <Evaluation />
	},
	{
		id: 'result',
		name: I18n.get('Result'),
		sequence: 2,
		description: I18n.get('Result'),
		component: <Result />
	}
];

export function Container() {
	const [form] = useForm();
	const breakpoints = useBreakpoint();
	const { parameters, currentStep, handleSetStep, handleSetData } = useOWASContext();
	const { isLoading, data, isSuccess, isError } = useGetOWASReport(parameters);

	async function handleOnStepChange(step: number): Promise<void> {
		handleSetStep(step);
	}

	useEffect(() => {
		if (data) {
			handleSetData(data);
		}
	}, [data, handleSetData]);

	useEffect(() => {
		if (isSuccess && data.current_step) {
			handleSetStep(data?.current_step ?? 0);
		}
	}, [isSuccess, data]);

	if (isLoading) {
		return <p>Loading</p>;
	}

	if (isError) {
		return <p>Error</p>;
	}

	const initialValues = {
		informations: {
			...data,
			organization_id: parameters?.organization_id,
			company_id: parameters?.company_id
		},
		comment: data?.comment
	};

	return (
		<Row gutter={[30, 0]}>
			<Col xs={24} xxl={4}>
				<StepsNavigation
					isComplete
					steps={steps}
					currentStep={currentStep}
					onStepNagivationClick={handleOnStepChange}
					direction={!breakpoints.xxl ? DIRECTION.HORIZONTAL : DIRECTION.VERTICAL}
				/>
			</Col>
			<Col xs={24} xxl={20}>
				<StepsContainer>
					<Form form={form} initialValues={initialValues}>
						{steps[currentStep].component}
					</Form>
				</StepsContainer>
			</Col>
		</Row>
	);
}
